<template>
  <div
    v-if="!!head"
    class="bdt-head mr-2 d-flex align-items-center justify-content-between"
  >
    <!-- Wrapped so a narrowed column (see resizableColumns.css) can cut the
         label off with an ellipsis while the search icon stays visible. The
         inline styles repeat that same truncation unscoped: resizableColumns.css
         only truncates under the opt-in .resizable-columns ancestor (a handful
         of invoicing tables), and every other table using this shared head
         still needs the identical fix - without it, this regresses the
         search-icon/sort-arrow overlap this page's columns had before. -->
    <span
      class="bdt-head-label"
      :title="head.label"
      style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; flex: 1 1 auto;"
    >
      <slot>{{ head.label }}</slot>
    </span>

    <template v-if="head.searchable || head.datePicker">
      <a
        :id="`base-data-table-popover-trigger-${tableId}-${$props.columnName}`"
        tabindex="0"
        class="ml-2"
        role="button"
        style="flex: 0 0 auto;"
      >
        <b-icon icon="search" :scale="0.9"></b-icon>
      </a>

      <BaseDataTableSearchPopover
        :column-name="$props.columnName"
        :target="`base-data-table-popover-trigger-${tableId}-${$props.columnName}`"
      >
        <template v-slot:default="data">
          <slot v-bind="data" :name="`search(${head.key})`" />
        </template>
      </BaseDataTableSearchPopover>
    </template>
  </div>
</template>

<script>
import { defineComponent, computed, inject } from '@vue/composition-api'

import { BaseDataTableInjectionKey } from './BaseDataTable.constants'

import BaseDataTableSearchPopover from './BaseDataTableSearchPopover.vue'

export default defineComponent({
  name: 'BaseDataTableTableHead',
  components: {
    BaseDataTableSearchPopover
  },
  props: {
    columnName: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { columns, tableId } = inject(BaseDataTableInjectionKey)

    const head = computed(() =>
      columns.value.find((column) => column.key === props.columnName)
    )

    return {
      head,
      tableId
    }
  }
})
</script>
